<template>
  <Multiselect
    :searchable="true"
    :filter-results="true"
    :resolve-on-load="true"
    :min-chars="0"
    :delay="0"
    :label="label"
    :value-prop="valueProp"
    :placeholder="placeholder"
    :options="asyncSource"
    :value="modelValue"
    v-bind="$attrs"
    :class="`multiselect-${size}`"
    @select="$emit('update:modelValue', $event)"
    @deselect="$emit('update:modelValue', null)"
    @clear="$emit('update:modelValue', null)" />
</template>

<script setup>
import Multiselect from '@vueform/multiselect'

defineProps({
  modelValue: {
    required: true,
    validator: (prop) => ['string', 'object', 'number'].includes(typeof prop) || prop === null
  },
  asyncSource: { type: Function, required: true },
  size: {
    type: String,
    default: 'default',
    validator: (prop) => ['default', 'lg', 'md', 'sm'].includes(prop)
  },
  label: { type: String, default: 'label' },
  valueProp: { type: String, default: 'value' },
  placeholder: { type: String, default: 'Select...' }
})

defineEmits(['update:modelValue'])
</script>
